<template>
<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-CloseOne`]" width="1em" height="1em" v-bind="$attrs"><path d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" :fill="useCurrentColor ? 'currentColor' : '#C6C6C6'"/><path d="M10.2628 5.7373L5.7373 10.2628M5.7373 5.7373L10.2628 10.2628" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconCloseOne',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
